/**
 * @generated SignedSource<<7f31fc03c816578a8cde0e9498ff41d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type noPermissions_projectsDirectoryV3$data = {
  readonly jira: {
    readonly canContactAdmin: ReadonlyArray<{
      readonly key: string;
      readonly value: string;
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "noPermissions_projectsDirectoryV3";
};
export type noPermissions_projectsDirectoryV3$key = {
  readonly " $data"?: noPermissions_projectsDirectoryV3$data;
  readonly " $fragmentSpreads": FragmentRefs<"noPermissions_projectsDirectoryV3">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "noPermissions_projectsDirectoryV3",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "alias": "canContactAdmin",
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Literal",
              "name": "keys",
              "value": "jira.show.contact.administrators.form"
            }
          ],
          "concreteType": "JiraApplicationProperty",
          "kind": "LinkedField",
          "name": "applicationPropertiesByKey",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "824d62f023722651098b2c7e7b3f2e7b";

export default node;
